import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-callout-style1',
  templateUrl: './callout-style1.component.html',
  styleUrls: ['./callout-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalloutStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/callouts/callout-style1/callout-style1.component.ts